import { put, select, takeLatest } from 'redux-saga/effects'
import { getServiceConfigSelector } from '../../configurations/selectors/serviceConfig.selector'
import { IServiceConfig } from '../../configurations/store/configurations.types'
import { PCRConstants } from '../../pcr/store/pcr.constants'
import * as actions from '../../patientInformation/store/patientInformation.actions'
import { IPatientInformationState } from '../store/patientInformation.types'
import { getPatientInformationState } from '../selectors'
import { PatientInformationConstants } from '../store/patientInformation.constants'

export function* setHidePatientAndBilling() {
  const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
  const patientInformation: IPatientInformationState = yield select(getPatientInformationState)
  const { searchImport, newPatient } = patientInformation
  const { FORCE_PT_SEARCH } = serviceConfig
  if (FORCE_PT_SEARCH === 1 && !searchImport && !newPatient) {
    yield put(actions.setSelectedOption(PatientInformationConstants.PATIENT_SEARCH_OPTION))
    yield put(actions.setHidePatientAndBilling(true))
  } else {
    yield put(actions.setSelectedOption(PatientInformationConstants.PATIENT_DEMOGRAPHICS_OPTION))
    yield put(actions.setHidePatientAndBilling(false))
  }
}

export function* setHidePatientAndBillingSaga() {
  yield takeLatest(
    [
      PCRConstants.CREATE_PCR,
      PatientInformationConstants.SET_PATIENT_INFORMATION,
      PatientInformationConstants.SET_SEARCH_IMPORT,
      PatientInformationConstants.SET_NEW_PATIENT,
    ],
    setHidePatientAndBilling
  )
}
